import React, { useState } from 'react';
import CreatorsTier from './CreatorsTier';
import CreatorsContactForm from './CreatorsContactForm';

const CreatorsTiers = ({ onSignUp }) => {
  const [showContactForm, setShowContactForm] = useState(false);
  const [contactContext, setContactContext] = useState();
  const onShowContactForm = context => {
    setContactContext(context);
    setShowContactForm(true);
  };
  return (
    <div id="pricing" className="CreatorsTiers">
      <CreatorsTier
        left
        name="Standard"
        targetGroup="Available to all, at no cost"
        // pricePerMonth="0"
        cta="Sign Up"
        onClick={onSignUp}
      >
        <div className="group">Unlimited Marbles</div>
        <div className="group">Basic Building Blocks</div>
        <ul>
          <li>Videos, Photos, Audio</li>
          <li>YouTube, Vimeo, Twitch</li>
          <li>Spotify, Soundcloud</li>
        </ul>
        <div className="group">Social Features</div>
        <ul>
          <li>Chats and Private Groups</li>
          <li>Marble Beams</li>
        </ul>
      </CreatorsTier>
      <CreatorsTier
        name="Business"
        targetGroup="For brands"
        // pricePerMonth="500"
        cta="Contact Sales"
        onClick={() => onShowContactForm('Professional Pricing Tier')}
      >
        {/* <div className="group">Remote Marble Placement</div> */}
        <div className="group">Gamification</div>
        <ul>
          <li>Collectibles and Tokens</li>
          <li>Rewards, Unlockable Areas</li>
          <li>Coupons</li>
        </ul>
        <div className="group">Marketing Tools</div>
        <ul>
          <li>Branding, Custom Marbles</li>
          <li>Own Channel</li>
          <li>Geofencing, Token Gating</li>
          <li>Campaigns, Analytics, Retargeting</li>
          <li>In-App Promotions, Sponsoring</li>
        </ul>
        <div className="group">Advanced Building Blocks</div>
        <ul>
          <li>Web Pages, PDFs, Shopify</li>
        </ul>
        <div className="group">Support</div>
      </CreatorsTier>
      <CreatorsTier
        right
        name="Non-Profit"
        targetGroup="For Non-Commercial Use"
        // customPrice="Custom"
        cta="Request Access"
        onClick={() => onShowContactForm('Non-Profit Tier')}
      >
        <p>
          <i>
            Available for non-commercial use at no cost. Perfect for schools, social projects, and
            personal initiatives.
          </i>
        </p>
        <div className="group">Gamification</div>
        <ul>
          <li>Collectibles and Rewards</li>
          <li>Unlockable Areas</li>
        </ul>
        <div className="group">Customization</div>
        <ul>
          <li>Branding, Custom Marbles</li>
          <li>Own Channel</li>
        </ul>
      </CreatorsTier>
      <div
        className="background"
        style={{ backgroundImage: 'url(/images/creators/tiers.background.svg)' }}
      />
      <CreatorsContactForm
        show={showContactForm}
        context={contactContext}
        onClose={() => setShowContactForm(false)}
      />
    </div>
  );
};

export default CreatorsTiers;
